export default {
  header: 'Menu',
  tabs: {
    menu: 'Menu',
    modifier_groups: 'Modificatori',
  },
  toasts: {
    failed_to_load_data: 'Impossibile caricare il menu. Aggiorna e riprova',
  },
};
